import React from 'react';
import '../../components/css/popupstyle.css';
import DashboardHeaderIcons from '../dashboardHeaderIcons';
import $ from 'jquery';
import { userService } from '../../_services/user.service';

class PayoutReportPopup extends React.Component {

    constructor(props) {
        super(props);
        this.reportData = this.reportData.bind(this);
        if (localStorage.getItem('user') == null || localStorage.getItem('user') == "" || localStorage.getItem('user') == "{}") {
            userService.logout();
        }
        try {
            this.state = {
                paramsName: JSON.parse(localStorage.getItem('user')).paramsname,
                MonthList: [],
                loader: false,
                error: ''
            };
        }
        catch (error) { }
    }
    componentDidMount() {
        this.GetCommission_Separate('admin', '');
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    GetCommission_Separate(UserEmail, RequestURL) {
        this.setState({ loader: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
            body: JSON.stringify({ UserEmail, RequestURL })
        };
        return fetch(`/api/admin/Revenue_Month`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        this.setState({ MonthList: apidata[0]["monthList"], loader: false, error: '' });
                    } else {
                        this.setState({ loader: false, error: 'Data not found' });
                    }
                }
                catch (error) {
                }
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    reportData(e) {        
        try {
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            let month_year = $("#commissionSelect").val();
            let paramsName = this.state.paramsName;
            window.open(
                Origin_Location + '/report/admin_payout_report?&month_year=' + month_year + '',
                '_blank' 
            );
            e.preventDefault();
        }
        catch (error) {}
    }


    render() {
        const { loader, error } = this.state;
        return (
            <div className='popup report-section mfp-zoom-in commission-edit popup-right-radius'>
                <div className='popup_inner'>

                    <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                    {
                        loader ? <div className="theme-loader commissionLoader"></div> : null
                    }
                    <div id="dashboard_header" className="big_dash_header">
                        <div className="dashboard-icons">

                            <DashboardHeaderIcons />

                        </div>
                        <div id="dashboard_header_inner">
                            <div id="dashboard-back-button"></div>
                            <div id="dashboard_header_select" className="admin-commission">
                                <form>
                                    <div className="selectSection payout">
                                        <label>Select Month, Year</label>
                                        <span className="down-arrow"></span>
                                        <select className="form-Control" id="commissionSelect" onChange={this.handleOnChange} value={this.state.value} >
                                            {
                                                this.state.MonthList != null ?
                                                    this.state.MonthList.map((obj, index) => {
                                                        return <option value={obj.monthYearname}>{obj.monthYearname.replace(',', ', ')}</option>
                                                    }) : null
                                            }
                                        </select>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="pop-btn ungap">
                                        <button className="btn" onClick={this.reportData}>Download</button>
                                        <button className="btn cancel" onClick={this.props.closePopup}>Cancel</button>
                                    </div>

                                </form>

                            </div>
                        </div>
                    </div>


                </div>
            </div>
        );
    }
}


export default PayoutReportPopup;